import * as React from "react";
import { forwardRef } from "react";
const BillIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "data-category": "documentation",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#bill-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.21967 1.71967C3.36032 1.57902 3.55109 1.5 3.75 1.5h9.75v5.25c0 .59674.2371 1.16903.659 1.59099.422.42196.9943.65901 1.591.65901H21v12.75c0 .1989-.079.3897-.2197.5303-.1406.1407-.3314.2197-.5303.2197H3.75c-.19891 0-.38968-.079-.53033-.2197C3.07902 22.1397 3 21.9489 3 21.75V2.25c0-.19891.07902-.38968.21967-.53033M20.6893 7.5H15.75c-.1989 0-.3897-.07902-.5303-.21967C15.079 7.13968 15 6.94891 15 6.75V1.81066zm1.8107.75v13.5c0 .5967-.2371 1.169-.659 1.591-.422.4219-.9943.659-1.591.659H3.75c-.59674 0-1.16903-.2371-1.59099-.659C1.73705 22.919 1.5 22.3467 1.5 21.75V2.25c0-.59674.23705-1.16903.65901-1.59099C2.58097.237053 3.15326 0 3.75 0h10.629c.5963.00012732 1.1684.236973 1.5902.6585l5.8721 5.87217c.4216.4218.6586.99385.6587 1.59017z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.25 15c0-.4142.3358-.75.75-.75h7c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-7c-.4142 0-.75-.3358-.75-.75",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#1B2733",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M6.75 19.5H18"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.812 5.25c0-.41421-.33579-.75-.75-.75s-.75.33579-.75.75v.36268c-.43078.09581-.82751.27369-1.15769.52127-.51535.38642-.90431.97764-.90431 1.69417 0 .7164.38884 1.30781.90406 1.69448.515.38651 1.19211.6035 1.90794.6035.42235 0 .77534.1294 1.00586.3025.23019.1729.30314.3549.30314.4935 0 .1378-.07286.3201-.30434.4937-.2274.1706-.57294.2986-.98553.3032l-.01912-.0002c-.01555 0-.03098.0004-.04629.0014-.23257.0073-.46362-.0406-.67423-.1398-.21436-.1009-.40123-.2521-.54476-.4406-.25092-.3296-.7215-.3933-1.05106-.1424s-.39332.7215-.1424 1.051c.2896.3804.66663.6854 1.09914.8891.1957.0921.40014.1623.6096.2098v.3525c0 .4142.33579.75.75.75.41422 0 .75-.3358.75-.75v-.3631c.42967-.0961.82527-.2738 1.15458-.5208.51531-.3864.90441-.9776.90441-1.6938 0-.7153-.3876-1.30631-.90236-1.69294-.51448-.38638-1.19099-.60304-1.90664-.60304-.42217 0-.77606-.12949-1.00756-.30323-.23128-.17358-.30444-.35618-.30444-.49477 0-.13847.07304-.32075.30419-.49408.23143-.17353.58538-.30292 1.00781-.30292.01013 0 .02025-.00021.03037-.00062.23662-.00959.47206.03809.6863.13899.21424.10089.40096.25202.54428.44054.25069.32974.72125.39382 1.05095.14314.3297-.25069.3938-.72122.1431-1.05096-.2894-.38075-.66654-.68599-1.09925-.88977-.19449-.09159-.39763-.16147-.60575-.20889zM6 19.5c0-.4142.33579-.75.75-.75H18c.4142 0 .75.3358.75.75s-.3358.75-.75.75H6.75c-.41421 0-.75-.3358-.75-.75",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "bill-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}))));
const ForwardRef = forwardRef(BillIcon);
ForwardRef.category = "documentation";
export { ForwardRef as BillIcon };